<template>
    <v-row no-gutters>
        <v-dialog v-model="dialog" persistent max-width="400">
            <v-progress-linear v-if="isLoading" indeterminate color="indigo darken-2"></v-progress-linear>
            <v-card>
                <v-card-title class="text-h5">
                    Konfirmasi
                </v-card-title>
                <v-card-text style="min-height: 50px;">Apakah anda yakin isian anda sudah benar?</v-card-text>
                <v-card-actions class="justify-content-center">
                    <v-spacer></v-spacer>
                    <v-btn :disabled="isLoading" color="indigo darken-4" text @click="onCloseDialog(false)">
                        Batal
                    </v-btn>
                    <v-btn :disabled="isLoading" color="indigo darken-4 white--text" @click="onCloseDialog(true)">
                        Simpan
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-container>
            <template>
                <v-alert text color="grey darken-1" class="p-4 rounded-lg " elevation="0">
                    <v-row style="line-height: 2rem;padding-left:20px;color: #000;">
                        <v-col cols="12" md="6" sm="6">
                            <tr>
                                <td><strong>Nama</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ detailData.name || '-' }}</td>
                            </tr>
                            <tr>
                                <td><strong>NIM</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ detailData.no_induk || '-' }}</td>
                            </tr>
                            <tr>
                                <td><strong>Email</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ detailData.email || '-' }}</td>
                            </tr>
                        </v-col>
                        <v-col cols="12" md="6" sm="6">
                            <tr>
                                <td><strong>No. Hp</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ detailData.no_hp || '-' }}</td>
                            </tr>
                            <tr>
                                <td><strong>IPK</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ detailData.ipk || '-' }}</td>
                            </tr>
                            <tr>
                                <td><strong>SKS</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ detailData.sks || '-' }}</td>
                            </tr>
                        </v-col>
                    </v-row>
                </v-alert>
                <v-tabs v-model="tabs" background-color="indigo lighten-5" grow elevation="1">
                    <v-tab href="#tab-1" active-class="indigo darken-3 white--text rounded-xl rounded-b-0">
                        Data
                    </v-tab>
                    <v-tab href="#tab-2" active-class="indigo darken-3 white--text rounded-xl rounded-b-0">
                        Riwayat
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabs">
                    <v-tab-item value="tab-1">
                        <v-stepper v-model="step" vertical>
                            <v-stepper-step complete step="1" @click="step = 1" style="cursor: pointer;">
                                Pendaftaran
                            </v-stepper-step>

                            <v-stepper-content step="1">
                                <v-card class="mb-12 rounded-xl grey lighten-4" elevation="0">
                                    <v-container class="p-4">
                                        <h6 class="text-body-1 pb-5 indigo--text text--darken-4">Isian<v-icon
                                                class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="4" class="pb-0 pt-0">
                                                <label class="mb-2 font-weight-bold">Tanggal daftar di sistem</label>
                                                <v-alert dense class="rounded-lg" elevation="1">
                                                    <div class="d-flex justify-space-between">
                                                        <div class="text-body-2">
                                                            {{ detailData.kp.created_at }}
                                                        </div>
                                                    </div>
                                                </v-alert>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="4" class="pb-0 pt-0">
                                                <label class="mb-2 font-weight-bold">Rencana mulai kp</label>
                                                <v-alert dense class="rounded-lg" elevation="1">
                                                    <div class="d-flex justify-space-between">
                                                        <div class="text-body-2">
                                                            {{ detailData.kp.tanggal_rencana_mulai_kp }}
                                                        </div>
                                                    </div>
                                                </v-alert>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="4" class="pb-0 pt-0">
                                                <label class="mb-2 font-weight-bold">Rencana selesai kp</label>
                                                <v-alert dense class="rounded-lg" elevation="1">
                                                    <div class="d-flex justify-space-between">
                                                        <div class="text-body-2">
                                                            {{ detailData.kp.tanggal_rencana_selesai_kp }}
                                                        </div>
                                                    </div>
                                                </v-alert>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                                <label class="mb-2 font-weight-bold">Kuliah prasyarat</label>
                                                <v-alert dense class="rounded-lg" elevation="1"
                                                    v-if="detailData.kp.matakuliah_prasyarat.length > 0">
                                                    <div class="d-flex">
                                                        <div class="text-body-2 mr-1"
                                                            v-for="(vals, indexItem) in detailData.kp.matakuliah_prasyarat">
                                                            <v-chip>{{ (indexItem + 1) + '. ' + vals.matakuliah
                                                            }}</v-chip>
                                                        </div>
                                                    </div>
                                                </v-alert>
                                                <v-alert dense class="rounded-lg" elevation="1" v-else>
                                                    -
                                                </v-alert>
                                            </v-col>
                                            <v-col>
                                                <v-col cols="12" sm="12" class="p-0" v-if="$isFTSP">
                                                    <label class="mb-2 font-weight-bold">Kategori perusahaan</label>
                                                    <v-alert dense class="rounded-lg" elevation="1">
                                                        <div class="d-flex justify-space-between">
                                                            <div class="text-body-2">
                                                                {{ detailData.kp.kategori_perusahaan.name }}
                                                            </div>
                                                        </div>
                                                    </v-alert>
                                                </v-col>
                                                <v-col cols="12" sm="12" class="p-0" v-if="$isFTSP">
                                                    <label class="mb-2 font-weight-bold">Bidang topik</label>
                                                    <v-alert dense class="rounded-lg" elevation="1">
                                                        <div class="d-flex justify-space-between">
                                                            <div class="text-body-2">
                                                                {{ detailData.kp.bidang_topik.name }}
                                                            </div>
                                                        </div>
                                                    </v-alert>
                                                </v-col>
                                                <v-col cols="12" sm="12" class="p-0">
                                                    <label class="mb-2 font-weight-bold">Nama perusahaan tujuan</label>
                                                    <v-alert dense class="rounded-lg" elevation="1">
                                                        <div class="d-flex justify-space-between">
                                                            <div class="text-body-2">
                                                                {{ detailData.kp.perusahaan_tujuan }}
                                                            </div>
                                                        </div>
                                                    </v-alert>
                                                </v-col>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="6" class="pb-0 pt-0 mt-2">
                                                <label class="mb-2 font-weight-bold">Alamat perusahaan</label>
                                                <v-alert dense class="rounded-lg" elevation="1" min-height="120px">
                                                    <div class="d-flex justify-space-between">
                                                        <div class="text-body-2">
                                                            {{ detailData.kp.alamat_perusahaan }}
                                                        </div>
                                                    </div>
                                                </v-alert>
                                            </v-col>
                                        </v-row>
                                        <v-divider class="indigo--text mb-0"></v-divider>
                                        <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4">Berkas<v-icon
                                                class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="6" class="pb-0 pt-0"
                                                v-for="( doc, index ) in detailData.kp.dokumen" v-bind:key="doc.id">
                                                <label class="mb-2 font-weight-bold">{{ (index + 1) +
                                                    '. ' + doc.nama_jenis_dokumen }}</label>
                                                <div v-if="doc.dokumen.length > 0">
                                                    <v-alert dense class="rounded-lg" elevation="1"
                                                        v-for="( file, fileIndex ) in doc.dokumen" v-bind:key="file.id">
                                                        <div class="d-flex justify-space-between">
                                                            <h6 class="text-body-2 mb-0">
                                                                {{ file.nama_dokumen }}
                                                                <p class="text-caption text-muted mb-0"> {{
                                                                    $dates.dateNoDayWithTime(file.created_at) }}</p>

                                                            </h6>
                                                            <a style="text-decoration:none;" :href="file.url"
                                                                target="_blank">
                                                                <v-icon>mdi-eye</v-icon>
                                                            </a>
                                                        </div>
                                                    </v-alert>
                                                </div>
                                                <div v-else>
                                                    <v-alert dense class="rounded-lg" elevation="1">
                                                        <div class="d-flex justify-space-between">
                                                            <div class="text-body-2 text-muted font-italic">
                                                                Tidak memiliki dokumen
                                                            </div>
                                                        </div>
                                                    </v-alert>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-divider class="indigo--text mb-0"></v-divider>
                                        <v-card class="mb-4 mt-4 rounded-xl grey lighten-5" elevation="1">
                                            <v-container class="p-4 pb-0">
                                                <h6 class="text-body-1indigo--text text--darken-4">Verifikasi
                                                    Pendaftaran<v-icon
                                                        class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                                <div class="form-group">
                                                    <v-radio-group v-model="formGroup.kode_status" row>
                                                        <v-radio label="Disetujui" value="PD"></v-radio>
                                                        <v-radio label="Perbaikan" value="PPP"></v-radio>
                                                    </v-radio-group>
                                                </div>
                                                <div class="row mt-2" v-if="formGroup.kode_status == 'PPP'">
                                                    <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                                        <label class="mb-2 font-weight-bold">Catatan</label>
                                                        <v-textarea v-model="formGroup.catatan" filled name="input-7-4"
                                                            label="catatan"></v-textarea>
                                                    </v-col>
                                                </div>
                                                <div v-if="$isFTSP && formGroup.kode_status == 'PD'">
                                                    <h6 class="text-body-1indigo--text text--darken-4 mb-4">Penunjukan
                                                        dosen pembimbing<v-icon
                                                            class="indigo--text text--darken-4">mdi-chevron-right</v-icon>
                                                    </h6>
                                                    <div class="row">
                                                        <v-col class="d-flex" cols="12" sm="12">
                                                            <v-autocomplete :items="listDosen"
                                                                v-model="formGroup.pembimbing[0]" item-text="name"
                                                                item-value="id" label="Pilih dosen pembimbing" solo
                                                                clearable>

                                                                <template v-slot:item="data">
                                                                    <template v-if="(typeof data.item !== 'object')">
                                                                        <v-list-item-content v-text="data.item">
                                                                        </v-list-item-content>
                                                                    </template>
                                                                    <template v-else>
                                                                        <v-list-item-avatar>
                                                                            <div v-if="data.item.avatar">
                                                                                <v-img width="40" height="40" cover
                                                                                    :src="data.item.avatar"></v-img>
                                                                            </div>
                                                                            <div v-else>
                                                                                <v-img width="40" height="40" cover
                                                                                    src="/images/user-profile.avif"></v-img>
                                                                            </div>
                                                                        </v-list-item-avatar>
                                                                        <v-list-item-content>
                                                                            <v-list-item-title
                                                                                v-html="data.item.name"></v-list-item-title>
                                                                            <v-list-item-subtitle>
                                                                                {{ `Bimbingan aktif:
                                                                                ${data.item.jumlah_bimbingan_aktif}
                                                                                `}}</v-list-item-subtitle>
                                                                        </v-list-item-content>
                                                                    </template>
                                                                </template>
                                                            </v-autocomplete>
                                                        </v-col>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-center p-3">
                                                    <v-btn :disabled="isLoading || !formGroup.kode_status" color="primary"
                                                        @click="onClickVerify(1)">
                                                        Verifikasi
                                                    </v-btn>
                                                </div>
                                            </v-container>
                                        </v-card>
                                    </v-container>
                                </v-card>
                            </v-stepper-content>

                            <v-stepper-step step="2">
                                Unggah Surat Balasan
                                <small>Realisasi mulai KP, Surat balasan</small>
                            </v-stepper-step>

                            <v-stepper-content step="2">

                            </v-stepper-content>

                            <v-stepper-step step="3">
                                Unggah Laporan KP
                                <small>Laporan KP, Logbook Kegiatan, Lembar penilaian</small>
                            </v-stepper-step>

                            <v-stepper-content step="3">

                            </v-stepper-content>

                            <v-stepper-step step="4">
                                Selesai
                            </v-stepper-step>

                            <v-stepper-content step="4">

                            </v-stepper-content>
                        </v-stepper>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                        <template>
                            <v-stepper v-model="stepers" vertical class="rounded-lg">
                                <h4
                                    class="text-body-1 font-weight-bold text-decoration-underline indigo--text text--darken-4 p-3">
                                    Riwayat pendaftaran</h4>
                                <div v-for="(item, index) in riwayat">
                                    <v-stepper-content step="">

                                    </v-stepper-content>

                                    <v-stepper-step step="">
                                        <v-row justify="space-between">
                                            <v-col cols="7">
                                                {{ item.status }} <br>
                                                <small v-if="item.catatan_aproval">Catatan: {{ item.catatan_aproval
                                                }}</small>
                                            </v-col>
                                            <v-col class="text-right" cols="5">
                                                <small>{{ item.time }}<br>{{ item.date }}</small>
                                            </v-col>
                                        </v-row>
                                    </v-stepper-step>
                                </div>
                            </v-stepper>
                        </template>
                    </v-tab-item>
                </v-tabs-items>
                <div class="d-flex justify-content-center">
                    <v-btn outlined color="primary" @click="buttonBackClick()">
                        Kembali
                    </v-btn>
                </div>
            </template>
        </v-container>
    </v-row>
</template>
<script>
import { serialize } from "object-to-formdata";
export default {
    data: () => ({
        dialog: false,
        isLoading: false,
        stepers: 1,
        riwayat: [],
        tabs: null,
        step: 1,
        listDosen: undefined,
        detailData: undefined,
        formGroup: {
            pembimbing: [],
            kode_status: undefined,
            catatan: null,
        }
    }),
    created() {
        this.getData();
        this.getListDosen();
    },
    methods: {
        getListDosen() {
            this.axios.get("/api/kp/dosen-pembimbing").then((res) => {
                this.listDosen = res.data.data;
            });
        },
        getData() {
            this.axios.get("/api/mahasiswa/kp/" + this.$route.query.read).then((res) => {
                this.detailData = res.data.data;
                this.detailData.kp.created_at = this.$dates.dateNoDayNoTime(this.detailData.kp.created_at);
                this.detailData.kp.tanggal_rencana_mulai_kp = this.$dates.dateNoDayNoTime(this.detailData.kp.tanggal_rencana_mulai_kp);
                this.detailData.kp.tanggal_rencana_selesai_kp = this.$dates.dateNoDayNoTime(this.detailData.kp.tanggal_rencana_selesai_kp);
                this.getRiwayat();
                this.getStep();
            }).finally(() => console.log('didit'));
        },
        getStep() {

        },
        onClickVerify(step) {
            this.dialog = true;
            // this.submit();
        },
        onCloseDialog(event) {
            if (event) {
                this.submit()
            } else {
                this.dialog = false;
            }
        },
        getRiwayat() {
            console.log('asdasd');
            this.axios.get("/api/kp/" + this.detailData.kp.id + '/riwayat').then((res) => {
                this.riwayat = res.data.data.sort();
                if (this.riwayat) {
                    this.riwayat = this.riwayat.map(val => {
                        val.time = new Date(val.created_at).getHours() + ':' + new Date(val.created_at).getMinutes();
                        val.date = new Date(val.created_at).toLocaleDateString('id-ID', { month: 'short', year: 'numeric', day: 'numeric' });
                        return val;
                    }).sort(function (a, b) {
                        var keyA = new Date(a.created_at),
                            keyB = new Date(b.created_at);
                        // Compare the 2 dates
                        if (keyA < keyB) return 1;
                        if (keyA > keyB) return -1;
                        return 0;
                    });
                }
            })
                .catch((err) => this.riwayat = null)
                .finally(() => console.log('riwayat->loaded'));
        },
        submit() {
            let url = "/api/verifikasi/pendaftaran/" + this.$route.query.read;
            this.isLoading = true;
            this.formGroup["_method"] = "PUT";
            const options = {
                indices: false,
                nullsAsUndefineds: false,
                booleansAsIntegers: false,
                allowEmptyArrays: false,
                noFilesWithArrayNotation: false,
                dotsForObjectNotation: false,
            };
            const formData = serialize(this.formGroup, options);
            this.axios
                .post(url, formData)
                .then((res) => {
                    this.$emit("toast", "success", "Berhasil verifikasi");
                    this.$router.push({ name: "verify-officer" });
                })
                .catch((err) => console.log(err))
                .finally(() => {
                    this.isLoading = false;
                    this.dialog = false;
                });
        },
        buttonBackClick() {
            this.$router.push({ name: "welcome" });
        },
    }
}
</script>
<style>
.card-file-download {
    font-size: calc(0.5em + 1vmin);
    cursor: pointer;

}

.card-file-download:hover {
    transform: scale(1.02);
    opacity: 0.5;
}

@media only screen and (max-width: 600px) {
    .card-file-download {
        font-size: calc(0.3em + 1vmin);
    }
}
</style>